import { combineReducers } from '@reduxjs/toolkit'
import projectReducer from './projectReducer.js'
import chatReducer from './chatReducer.js'
import assistantReducer from './assistantReducer.js'
import digestReducer from './digestReducer.js'
import taskReducer from './taskReducer.js'
import emailJobReducer from './emailJobReducer.js'
import taskCategoryReducer from './taskCategoryReducer.js'
import maintenanceTicketReducer from './maintenanceTicketReducer.js'
import responsePartnerReducer from './responsePartnerReducer.js'

export const rootReducer = combineReducers({
    projectList: projectReducer,
    taskList: taskReducer,
    maintenanceTicketList: maintenanceTicketReducer,
    chats: chatReducer,
    assistant: assistantReducer,
    digestList: digestReducer,
    emailJobs: emailJobReducer,
    taskCategoryList: taskCategoryReducer,
    responsePartnerList: responsePartnerReducer,
});
